import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
    contentDiv: {
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.background.invoice,
      color: 'black'
    },
    card: {
      backgroundColor: theme.palette.background.invoice,
      lineHeight: '25px',
      fontSize: '1.1em',
      color: 'black',
      display: 'flex',
      flexGrow: 1,
      flexDirection: "column",
      justifyContent: "space-between",
      height: '100%',
      margin: 'auto 20px',
      paddingTop: '20px',
      paddingBottom: '20px',
    },
    icon: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        '& .MuiSvgIcon-root': {
            marginRight: 5,
        },
    },
    stepCompleted: {
        root : {
            color: 'green'
        }
    },
    layoutContainer: {
      height: 200,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: theme.spacing(2),
      border: "1px dashed",
      borderColor: theme.palette.primary.main,
      position: "relative"
    },
    layoutText: {
      color: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    layoutButtonsRow: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    },
    layoutButton: {
      backgroundColor: theme.palette.background.light,
      width: 125,
      height: 50,
      outline: "none",
      border: "none"
    },
    layoutButtonActive: {
      backgroundColor: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginTop: theme.spacing(2)
    },
    notificationCallButton: {
      color: "white",
      marginBottom: theme.spacing(1),
      textTransform: "none"
    },
    codeContainer: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(2)
    },
    codeComponent: {
      flexGrow: 1
    },
    notificationItem: {
      marginTop: theme.spacing(2)
    },
    notificationCloseButton: {
      position: "absolute",
      right: theme.spacing(2)
    },
    toastsContainer: {
      width: "auto",
      marginTop: theme.spacing(6),
      right: 0
    },
    progress: {
      visibility: "hidden"
    },
    notification: {
      display: "flex",
      alignItems: "center",
      background: "transparent",
      boxShadow: "none",
      overflow: "visible"
    },
    header: {
      fontSize: '32px',
      fontWeight: 'bold',
      textAlign: 'center',
      color: theme.palette.primary.main,
      marginBottom: '28px',
      gridColumnStart: '2',
    },
    bigHeader: {
      display: 'grid',
      gridTemplateColumns: '1fr repeat(1, auto) 1fr',
      gridColumnGap: '5px',
      justifyItems: 'center'
    },
    details: {
      display: 'grid',
      gridTemplateColumns: '[first] 20% [line2] auto [end]',
      borderStyle: 'none none solid none',
      paddingBottom: '5px',
      width: '100%'
    },
    reportedUploads: {
      display: 'grid',
      gridTemplateColumns: '15% 15% 10% 10% 7% 7% 7% 7% 7% 7% 7%',
      borderStyle: 'none none solid none',
      borderWidth: 'thin',
    },
    reportedUploadsSummary: {
      display: 'grid',
      gridTemplateColumns: '15% 15% 10% 10% 7% 7% 7% 7% 7% 7% 7%',
      borderStyle: 'none none solid none',
    },
    actualUploads: {
      display: 'grid',
      gridTemplateColumns: '15% 15% 10% 10% 7% 7% 7% 7% 7% 7% 7%',
      borderStyle: 'none none solid none',
      borderWidth: 'thin',
    },
    actualUploadsSummary: {
      display: 'grid',
      gridTemplateColumns: '15% 15% 10% 10% 7% 7% 7% 7% 7% 7% 7%',
      borderStyle: 'none none solid none',
    },
    diff: {
      display: 'grid',
      gridTemplateColumns: '15% 15% 10% 10% 7% 7% 7% 7% 7% 7% 7%',
      borderStyle: 'none none solid none',
      borderTopStyle: 'solid',
      borderTopWidth: 'thin'
    },
    assetNoDesc: {
      display: 'grid',
      gridTemplateColumns: '15% 75%',
      borderStyle: 'none none solid none',
      borderBottomWidth: 'thin'
    },
    assetNoDescSummary: {
      display: 'grid',
      gridTemplateColumns: '15% 15% 10% 10% 7% 7% 7% 7% 7% 7% 7%',
      borderStyle: 'none none solid none',
    },
    chargeableHours: {
      display: 'grid',
      gridTemplateColumns: '33% 33% 33%',
      borderStyle: 'none none solid none',
      borderBottomWidth: 'thin'
    },
    chargeableHoursSummary1: {
      display: 'grid',
      gridTemplateColumns: '33% 33% 33%',
      borderStyle: 'none none solid none',
    },
    chargeableHoursSummary2: {
      display: 'grid',
      gridTemplateColumns: '33% 33% 33%',
      borderStyle: 'none none solid none',
    },
    parking: {
      display: 'grid',
      gridTemplateColumns: '33% 33% 33%',
      borderStyle: 'none none solid none',
      borderBottomWidth: 'thin'
    },
    parkingPerTech: {
      display: 'grid',
      gridTemplateColumns: '50% 50%',
      borderStyle: 'none none solid none',
      borderBottomWidth: 'thin'
    },
    lateSubmitText: {
        color: '#ff0000',
    },
     parkingSummary: {
      display: 'grid',
      gridTemplateColumns: '33% 33% 33%',
      borderStyle: 'none none solid none',
    },
    assetTestSummary: {
      display: 'grid',
      gridTemplateColumns: '50% 50%',
    },
    assetTestSummarySummary: {
      borderStyle: 'none none solid none',
    },
    repariDetails: {
      display: 'grid',
      gridTemplateColumns: '10% 20% 20% 50%',
      borderStyle: 'none none solid none',
      borderBottomWidth: 'thin'
    },
    repairsSummary: {
      display: 'grid',
      gridTemplateColumns: '10% 20%',
      borderStyle: 'none none solid none',
    },
    duplicatedTests: {
      display: 'grid',
      gridTemplateColumns: '10% 15% 15% 10% 10% 20% 20%',
      borderStyle: 'none none solid none',
    },
    duplicatedTestSummary: {
      borderStyle: 'none none solid none',
    },
    faultyItems: {
      display: 'grid',
      gridTemplateColumns: '20% 20% 20% 20% 20%',
    },
    faultyItemsSummary: {
      borderStyle: 'none none solid none',
    },
    jobcard: {
      display: 'grid',
      gridTemplateColumns: '20% 20% 60%',
    },
    jobcardSummary: {
      borderStyle: 'none none solid none',
    },
    timesheet: {
      display: 'grid',
      gridTemplateColumns: '10% 20% 70%',
    },
    timesheetSummary: {
      borderStyle: 'none none solid none',
    },
    siteVisits: {
      display: 'grid',
      gridTemplateColumns: '33% 33% 33%',
    },
    siteVisitsSummary: {
      borderStyle: 'none none solid none',
    },
    summaryRow: {
      padding: '5px 0'
    },
    bigTitle: {
      fontSize: '1.5em',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      marginTop: '2em'
    },
    title: {
      fontWeight: 'bold'
    },
    centerText: {
      textAlign: 'center'
    },
    borderRight: {
      borderStyle: 'none solid none none',
      borderWidth: 'thin'
    },
    footer: {
      fontSize: '0.8em',
      fontStyle: 'italic'
    },
    flex: {
      display: 'flex'
    },
    breakWord:  {
      wordWrap: 'break-word'
    },
    failedImage: {
      maxWidth: '100%',
      width: 'auto'
    },
    repairedImage: {
      maxWidth: '100%',
      width: 'auto'
    },
    topButtons: {
      marginLeft: 'auto'
    },
    noPrint: {
      display: 'none !important'
    },
    button: {
      color: 'black',
      "&:hover, &:focus": {
        backgroundColor: theme.lightgrey,
      }
    },
    toolbarContent: {
     		display: 'inline-flex'
    },
    zoomDiv: {
        width: '250px',
     		paddingRight: '15px',
     		borderRightStyle: 'solid',
    		bordeRightWidth: '2px',
    		borderColor: 'lightgrey'
    },
    zoomLabel: {
        color: theme.lightgrey,
        fontSize: '20px'
    },
    columnCountContainer: {
     		padding: '0 20px 0 15px',
		    width: '80px',
		    borderRightStyle: 'solid',
		    borderRightWidth: '2px',
		    borderColor: 'lightgrey'
    },
    toolbarHideImageDiv: {
        marginLeft: '10px',
        marginTop: '20px'
    },
    input: {
      width: 42,
    },
    toolbar: {
      border: '1px #D3D3D3 solid',
      borderRadius: '5px',
      boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      width: '600px',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: '20px'
    },
    printView: {
      width: '40cm',
      height: '26cm',
      border: '1px #D3D3D3 solid',
      borderRadius: '5px',
      background: 'white',
      boxShadow: '0 0 0.5cm rgba(0,0,0,0.5)',
      margin: '0 auto',
      fontSize: 'initial'
    },
    printableArea: {
      color: 'black',
      '-webkit-print-color-adjust': 'exact'
    },
    toolbarBox: {
      '& > *': {
        margin: '0 5px'
      }
    },
    xeroButton: {
        minWidth: '200px'
    },
    breakable: {
        wordBreak: 'break-word'
    }
}))
